import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import './Carousel.css';

import carImage from './assets/car22.jpg';
import flightImage from './assets/flight22.jpg';
import hotelImage from './assets/hotel11.jpg';
import trainImage from './assets/train22.jpg';

const Carousel = ({ userLocation }) => {
  const [isDragging, setIsDragging] = useState(false);
  const [startPos, setStartPos] = useState(0);
  const [currentTranslate, setCurrentTranslate] = useState(0);
  const [prevTranslate, setPrevTranslate] = useState(0);
  const carouselRef = useRef(null);

  const itemWidth = 320;

  const locationName = [
    userLocation?.district,
    userLocation?.country
  ].filter(Boolean).join(',');

  const today = new Date();
  const startDate = new Date(today);
  startDate.setDate(today.getDate() + 1);
  const endDate = new Date(today);
  endDate.setDate(today.getDate() + 2);

  const formatDate = (date) => date.toISOString().split('T')[0];
  const formattedStart = formatDate(startDate);
  const formattedEnd = formatDate(endDate);

  // Helper to sanitize location for Kayak
  function sanitizeKayakLocation(location) {
    if (!location) return '';
    const parts = location.split(',');
    const city = parts[0] || '';
    const country = parts[parts.length - 1] || '';
    return `${city},${country}`.trim();
  }

  // Mapping of major Malaysia cities to Kayak place IDs
  const kayakPlaceIds = {
    "George-Town,Malaysia": "p247880",
    "Penang,Malaysia": "p247880",
    "Kuala-Lumpur,Malaysia": "p30606",
    "Langkawi,Malaysia": "p20734",
    "Johor-Bahru,Malaysia": "p16297",
    "Kota-Kinabalu,Malaysia": "p30609",
    "Ipoh,Malaysia": "p30607",
    "Kuching,Malaysia": "p30610",
    "Malacca,Malaysia": "p30608",
    "Putrajaya,Malaysia": "p30612",
    "Shah-Alam,Malaysia": "p30613",
    "Petaling-Jaya,Malaysia": "p30611",
    "Alor-Setar,Malaysia": "p30614",
    "Kuantan,Malaysia": "p30615",
    "Miri,Malaysia": "p30616",
    "Sandakan,Malaysia": "p30617",
    "Bintulu,Malaysia": "p30618",
    "Seremban,Malaysia": "p30619",
    "Taiping,Malaysia": "p30620",
    "Kota-Bharu,Malaysia": "p30621",
    "Kuala-Terengganu,Malaysia": "p30622",
    "Sibu,Malaysia": "p30623",
    "Labuan,Malaysia": "p30624",
    "Cameron-Highlands,Malaysia": "p30625",
    "Genting-Highlands,Malaysia": "p30626",
    "Bukit-Bintang,Malaysia": "p30627",
    "Batu-Ferringhi,Malaysia": "p30628",
    "Sepang,Malaysia": "p30629",
    "Cyberjaya,Malaysia": "p30630",
    "Ampang,Malaysia": "p30631",
    "Subang-Jaya,Malaysia": "p30632",
    "Kajang,Malaysia": "p30633",
    "Sungai-Petani,Malaysia": "p30634",
    "Klang,Malaysia": "p30635",
    "Nilai,Malaysia": "p30636",
    "Port-Dickson,Malaysia": "p30637",
    "Muar,Malaysia": "p30638",
    "Skudai,Malaysia": "p30639",
    "Batu-Pahat,Malaysia": "p30640",
    "Kluang,Malaysia": "p30641",
    "Tawau,Malaysia": "p30642",
    "Bentong,Malaysia": "p30643",
    "Raub,Malaysia": "p30644",
    "Kangar,Malaysia": "p30645",
    "Lumut,Malaysia": "p30646",
    "Marang,Malaysia": "p30647",
    "Dungun,Malaysia": "p30648",
    "Jitra,Malaysia": "p30649",
    "Manjung,Malaysia": "p30650",
    "Tanjung-Malim,Malaysia": "p30651",
    "Kuala-Selangor,Malaysia": "p30652",
    "Rawang,Malaysia": "p30653",
    "Selayang,Malaysia": "p30654",
    "Semenyih,Malaysia": "p30655",
    "Bangi,Malaysia": "p30656",
    "Tampin,Malaysia": "p30657",
    "Segamat,Malaysia": "p30658",
    "Keningau,Malaysia": "p30659",
    "Beaufort,Malaysia": "p30660",
    "Lahad-Datu,Malaysia": "p30661",
    "Papar,Malaysia": "p30662",
    "Kudat,Malaysia": "p30663",
    "Sipitang,Malaysia": "p30664",
    "Beluran,Malaysia": "p30665",
    "Kapit,Malaysia": "p30666",
    "Samarahan,Malaysia": "p30667",
    "Mukah,Malaysia": "p30668",
    "Sri-Aman,Malaysia": "p30669",
    "Sarikei,Malaysia": "p30670",
    "Marudi,Malaysia": "p30671",
    "Limbang,Malaysia": "p30672",
    "Lawas,Malaysia": "p30673",
    "Simanggang,Malaysia": "p30674",
    "Tanjung-Tokong,Malaysia": "p30675",
    "Balik-Pulau,Malaysia": "p30676",
    "Butterworth,Malaysia": "p30677",
    "Seberang-Jaya,Malaysia": "p30678",
    "Bukit-Mertajam,Malaysia": "p30679",
    "Taiping,Malaysia": "p30680",
    "Teluk-Intan,Malaysia": "p30681",
    "Kuala-Kangsar,Malaysia": "p30682",
    "Sungai-Siput,Malaysia": "p30683",
    "Parit-Buntar,Malaysia": "p30684",
    "Batu-Gajah,Malaysia": "p30685",
    "Tapah,Malaysia": "p30686",
    "Bidor,Malaysia": "p30687",
    "Kampar,Malaysia": "p30688",
    "Sitiawan,Malaysia": "p30689",
    "Langkawi-Island,Malaysia": "p30690",
    "Pekan,Malaysia": "p30691",
    "Temerloh,Malaysia": "p30692",
    "Jerantut,Malaysia": "p30693",
    "Mentakab,Malaysia": "p30694",
    "Rompin,Malaysia": "p30695",
    "Raub,Malaysia": "p30696",
    "Bentong,Malaysia": "p30697",
    "Kuala-Lipis,Malaysia": "p30698",
    "Kuala-Rompin,Malaysia": "p30699",
    "Kuala-Krai,Malaysia": "p30700",
    "Tanah-Merah,Malaysia": "p30701",
    "Pasir-Mas,Malaysia": "p30702",
    "Pasir-Puteh,Malaysia": "p30703",
    "Machang,Malaysia": "p30704",
    "Gua-Musang,Malaysia": "p30705",
    "Jeli,Malaysia": "p30706",
    "Tumpat,Malaysia": "p30707",
    "Besut,Malaysia": "p30708",
    "Setiu,Malaysia": "p30709",
    "Hulu-Terengganu,Malaysia": "p30710",
    "Kemaman,Malaysia": "p30711",
    "Marang,Malaysia": "p30712",
    "Dungun,Malaysia": "p30713",
    "Kuala-Nerus,Malaysia": "p30714",
    "Kuala-Terengganu,Malaysia": "p30715",
    "Labuan-Island,Malaysia": "p30716",
    "Putatan,Malaysia": "p30717",
    "Penampang,Malaysia": "p30718",
    "Tuaran,Malaysia": "p30719",
    "Ranau,Malaysia": "p30720",
    "Kota-Marudu,Malaysia": "p30721",
    "Pitas,Malaysia": "p30722",
    "Beluran,Malaysia": "p30723",
    "Kinabatangan,Malaysia": "p30724",
    "Tongod,Malaysia": "p30725",
    "Telupid,Malaysia": "p30726",
    "Kunak,Malaysia": "p30727",
    "Semporna,Malaysia": "p30728",
    "Nabawan,Malaysia": "p30729",
    "Tenom,Malaysia": "p30730",
    "Sipitang,Malaysia": "p30731",
    "Keningau,Malaysia": "p30732",
    "Beaufort,Malaysia": "p30733",
    "Papar,Malaysia": "p30734",
    "Kota-Belud,Malaysia": "p30735",
    "Kota-Kinabalu,Malaysia": "p30736",
    "Kota-Samarahan,Malaysia": "p30737",
    "Lundu,Malaysia": "p30738",
    "Bau,Malaysia": "p30739",
    "Serian,Malaysia": "p30740",
    "Simunjan,Malaysia": "p30741",
    "Asajaya,Malaysia": "p30742",
    "Sebuyau,Malaysia": "p30743",
    "Sri-Aman,Malaysia": "p30744",
    "Lubok-Antu,Malaysia": "p30745",
    "Betong,Malaysia": "p30746",
    "Saratok,Malaysia": "p30747",
    "Sarikei,Malaysia": "p30748",
    "Julau,Malaysia": "p30749",
    "Pakan,Malaysia": "p30750",
    "Sibu,Malaysia": "p30751",
    "Kanowit,Malaysia": "p30752",
    "Selangau,Malaysia": "p30753",
    "Mukah,Malaysia": "p30754",
    "Dalat,Malaysia": "p30755",
    "Matu,Malaysia": "p30756",
    "Daro,Malaysia": "p30757",
    "Tanjung-Manis,Malaysia": "p30758",
    "Kapit,Malaysia": "p30759",
    "Song,Malaysia": "p30760",
    "Belaga,Malaysia": "p30761",
    "Bintulu,Malaysia": "p30762",
    "Tatau,Malaysia": "p30763",
    "Sebauh,Malaysia": "p30764",
    "Miri,Malaysia": "p30765",
    "Marudi,Malaysia": "p30766",
    "Subis,Malaysia": "p30767",
    "Limbang,Malaysia": "p30768",
    "Lawas,Malaysia": "p30769"
  };
  

  // Only use the city/place name for Kayak hotel links
  const destinationName = userLocation?.district || userLocation?.city || userLocation?.place || "";
  const encodedCityName = encodeURIComponent(destinationName.replace(/\s+/g, '-'));
  const kayakPlaceId = kayakPlaceIds[`${destinationName},Malaysia`] || "";
  const encodedHotelPath = kayakPlaceId
    ? `/hotels/${encodedCityName},Malaysia-${kayakPlaceId}/${formattedStart}/${formattedEnd}/1adults`
    : `/hotels/${encodedCityName},Malaysia/${formattedStart}/${formattedEnd}/1adults`;

  // Helper to build Kayak hotel link with fallback
  function buildKayakHotelLink(encodedCityName, kayakPlaceId, formattedStart, formattedEnd) {
    // Try with place ID
    let hotelPathWithId = kayakPlaceId
      ? `/hotels/${encodedCityName},Malaysia-${kayakPlaceId}/${formattedStart}/${formattedEnd}/1adults`
      : `/hotels/${encodedCityName},Malaysia/${formattedStart}/${formattedEnd}/1adults`;
    let hotelLinkWithId = `https://www.kayak.com.my/in?a=kan_262812_573418&encoder=27_1&enc_cid=760&lc=en&url=${encodeURIComponent(hotelPathWithId)}`;
    // Fallback: generic city/country only
    let hotelPathFallback = `/hotels/${encodedCityName},Malaysia/${formattedStart}/${formattedEnd}/1adults`;
    let hotelLinkFallback = `https://www.kayak.com.my/in?a=kan_262812_573418&encoder=27_1&enc_cid=760&lc=en&url=${encodeURIComponent(hotelPathFallback)}`;
    return { hotelLinkWithId, hotelLinkFallback };
  }

  // Build Kayak hotel link using state-specific logic for Malaysia
  let urlmain;
  const creatorId = "760"; // or your dynamic value
  const formattedDate1 = formattedStart;
  const formattedDate2 = formattedEnd;
  if (destinationName === 'Sabah') {
      urlmain = `https://kayak.com.my/in?a=kan_262812_573418&enc_cid=${creatorId}&lc=en&url=%2Fhotels/Sabah,Malaysia-p21083/${formattedDate1}/${formattedDate2}?sort=distance_a`;
  } else if (destinationName === 'Pahang') {
      urlmain = `https://kayak.com.my/in?a=kan_262812_573418&enc_cid=${creatorId}&lc=en&url=%2Fhotels/Pahang,Malaysia-p21086/${formattedDate1}/${formattedDate2}?sort=distance_a`;
  } else if (destinationName === 'Penang') {
      urlmain = `https://kayak.com.my/in?a=kan_262812_573418&enc_cid=${creatorId}&lc=en&url=%2Fhotels/Penang,Malaysia-p247880/${formattedDate1}/${formattedDate2}?sort=distance_a`;
  } else if (destinationName === 'Sarawak') {
      urlmain = `https://kayak.com.my/in?a=kan_262812_573418&enc_cid=${creatorId}&lc=en&url=%2Fhotels/Sarawak,Malaysia-p21082/${formattedDate1}/${formattedDate2}?sort=distance_a`;
  } else if (destinationName === 'Kedah') {
      urlmain = `https://kayak.com.my/in?a=kan_262812_573418&enc_cid=${creatorId}&lc=en&url=%2Fhotels/Kedah,Malaysia-p21092/${formattedDate1}/${formattedDate2}?sort=distance_a`;
  } else if (destinationName === 'Selangor') {
      urlmain = `https://kayak.com.my/in?a=kan_262812_573418&enc_cid=${creatorId}&lc=en&url=%2Fhotels/Selangor,Malaysia-p21081/${formattedDate1}/${formattedDate2}?sort=distance_a`;
  } else if (destinationName === 'Negeri Sembilan') {
      urlmain = `https://kayak.com.my/in?a=kan_262812_573418&enc_cid=${creatorId}&lc=en&url=%2Fhotels/Negeri-Sembilan,Malaysia-p21087/${formattedDate1}/${formattedDate2}?sort=distance_a`;
  } else if (destinationName === 'Kelantan') {
      urlmain = `https://kayak.com.my/in?a=kan_262812_573418&enc_cid=${creatorId}&lc=en&url=%2Fhotels/Kelantan-p21088/${formattedDate1}/${formattedDate2}?sort=distance_a`;
  } else {
      let encodedCityName = encodeURIComponent(destinationName);
      urlmain = `https://kayak.com.my/in?a=kan_262812_573418&enc_cid=${creatorId}&lc=en&url=%2Fhotels/${encodedCityName}/${formattedDate1}/${formattedDate2}?sort=distance_a`;
  }
  const hotelLink = urlmain;


  const travelOptions = [
    {
      id: 'hotels',
      title: 'Hotel Deals',
      image: hotelImage,
      link: hotelLink
    },
    {
      id: 'cars',
      title: 'Car Rentals',
      image: carImage,
      link: `https://www.kayak.com.my/in?a=kan_262812_573418&encoder=27_1&enc_cid=760&lc=en&url=%2Fcars&location=${encodeURIComponent(locationName)}`
    },
    {
      id: 'Flight',
      title: 'Flight Deals',
      image: flightImage,
      link: `https://www.kayak.com.my/in?a=kan_262812_573418&encoder=27_1&enc_cid=760&lc=en&url=%2Fflights&location=${encodeURIComponent(locationName)}`
    },
    {
      id: 'trains',
      title: 'KTM Tickets',
      image: trainImage,
      link: process.env.REACT_APP_ETS_URL || 'mpay.apps.kits.superapp.uat.scheme://ai_journey?goWhere=ets_intercity'
    }
  ];

  const extendedOptions = [...travelOptions, ...travelOptions, ...travelOptions];

  const handleTouchStart = (e) => {
    setIsDragging(true);
    setStartPos(e.touches ? e.touches[0].clientX : e.clientX);
    setPrevTranslate(currentTranslate);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const currentPosition = e.touches ? e.touches[0].clientX : e.clientX;
    const diff = currentPosition - startPos;
    const newTranslate = prevTranslate + diff;
    setCurrentTranslate(newTranslate);
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
    const currentIndex = Math.round(-currentTranslate / itemWidth);
    setCurrentTranslate(-currentIndex * itemWidth);
  };

  const handleOptionClick = (option) => {
    if (isDragging) return;

    if (option.link.startsWith('http')) {
      window.open(option.link, '_blank'); // 🌐 Open web link in new tab
    } else {
      window.location.href = option.link; // 🔗 Open deep link (mobile)
    }
  };

  useEffect(() => {
    setCurrentTranslate(-travelOptions.length * itemWidth);
  }, []);

  return (
    <div className="carousel-container">
      <div
        className="carousel-track"
        ref={carouselRef}
        style={{
          transform: `translateX(${currentTranslate}px)`,
          transition: isDragging ? 'none' : 'transform 0.3s ease-out',
        }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        onMouseDown={handleTouchStart}
        onMouseMove={handleTouchMove}
        onMouseUp={handleTouchEnd}
        onMouseLeave={handleTouchEnd}
      >
        {extendedOptions.map((option, index) => (
          <div
            key={`${option.id}-${index}`}
            className="carousel-item"
            onClick={() => handleOptionClick(option)}
          >
            <img
              src={option.image}
              alt={option.title}
              className="carousel-image"
              draggable="false"
            />
            {/* <div className="carousel-title">{option.title}</div> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Carousel;
